export const MOBILE_USER_LOGIN_START = 'MOBILE_USER_LOGIN_START';
export const MOBILE_USER_LOGIN_SUCCESS = 'MOBILE_USER_LOGIN_SUCCESS';
export const MOBILE_USER_LOGIN_FAIL = 'MOBILE_USER_LOGIN_FAIL';

export const MOBILE_USER_REGISTRATION_START = 'MOBILE_USER_REGISTRATION_START';
export const MOBILE_USER_REGISTRATION_SUCCESS = 'MOBILE_USER_REGISTRATION_SUCCESS';
export const MOBILE_USER_REGISTRATION_FAIL = 'MOBILE_USER_REGISTRATION_FAIL';

export const RESTORE_MOBILE_START = 'RESTORE_MOBILE_START';
export const RESTORE_MOBILE_SUCCESS = 'RESTORE_MOBILE_SUCCESS';
export const RESTORE_MOBILE_FAIL = 'RESTORE_MOBILE_FAIL';

export const CONFIRM_USER_REGISTRATION_START = 'CONFIRM_USER_REGISTRATION_START';
export const CONFIRM_USER_REGISTRATION_SUCCESS = 'CONFIRM_USER_REGISTRATION_SUCCESS';
export const CONFIRM_USER_REGISTRATION_FAIL = 'CONFIRM_USER_REGISTRATION_FAIL';

export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR';
